import { types, Image } from "react-bricks/frontend";
import styled from "styled-components";

export interface LogoWallImageProps {
  maxWidth?: number;
  maxHeight?: number;
}

const LogoWallImage: types.Brick<LogoWallImageProps> = ({ maxWidth, maxHeight }) => {
  const style = maxHeight ? { height: `${maxHeight}px` } : { width: `${maxWidth}px` };

  return (
    <Image
      propName="logoImage"
      alt="logoImage"
      maxWidth={maxHeight ? undefined : maxWidth} // only use maxWidth if maxHeight isn’t provided
      renderWrapper={({ children }) => <ImageWrapper style={style}>{children}</ImageWrapper>}
      placeholder={() => "/static/logos/BupaLogo.png"}
    />
  );
};

LogoWallImage.schema = {
  name: "logo-wall-image",
  label: "Logo Wall Image",
  category: "Logo Wall",
  hideFromAddMenu: true,
  repeaterItems: [],
  getDefaultProps: () => ({
    maxWidth: 188,
  }),
  sideEditProps: [],
};

const ImageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  height: ${(props) => props.style?.height || "auto"};
  width: ${(props) => props.style?.width || "auto"};

  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
`;

export default LogoWallImage;
